import {createFeatureSelector, createSelector} from '@ngrx/store';
import {StoreKeys} from '../../../models/store-keys';
import {TaskSearchResultState} from './reducer/task-search-result.reducer';

export const selectTaskSearchResultFeature = createFeatureSelector<TaskSearchResultState>(StoreKeys.TASK_SEARCH_RESULT);

export const selectTaskSearchResultDatas = createSelector(selectTaskSearchResultFeature, state => state.datas);

export const selectTaskSearchResultDatasContent = createSelector(selectTaskSearchResultDatas, state => state?.content);
